import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';

type MessageBarContainerProps = {
  children: React.ReactNode;
  width?: string;
  minWidth?: string;
  height?: string;
  standalone?: boolean;
  sx?: SxProps<Theme>;
};

export const MessageBarContainer = (props: MessageBarContainerProps) => {
  return (
    <Box
      className='hide-scrollbar'
      sx={{
        bgcolor: 'white',
        width: props.width ?? '100%',
        minWidth: props.minWidth,
        height: props.height ?? '100%',
        px: 0,
        pt: 2.5,
        boxShadow:
          '0 12px 16px 0 rgba(59, 69, 89, 0.05), 0 8px 10px 0 rgba(59, 69, 89, 0.1)',
        display: 'flex',
        flexDirection: 'column',
        borderRight: 'solid 0.5px #d8dade',
        overflow: 'auto',
        ...(props.standalone && {
          border: 'solid 0.5px #d8dade',
          borderTopLeftRadius: '15px',
          borderTopRightRadius: '15px',
        }),
        ...props.sx,
      }}
    >
      {props.children}
    </Box>
  );
};
